/**
 * Anmeldung des Service Workers.
 *
 * Der Worker ist der Grund, warum die App ohne Netz weiterläuft: er legt beim ersten
 * Besuch alles ab, was im Build liegt, und bedient danach jede Anfrage aus dem Speicher.
 * Ohne ihn fehlt nur die Offline-Nutzung, alles andere läuft wie bisher, deshalb bricht
 * ein Fehler hier nichts ab.
 */

export type OfflineState = 'ready' | 'pending' | 'off'

export function register(): void {
  if (!('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
      // Ohne Worker läuft die App weiter, nur eben nicht ohne Netz.
    })
  })
}

/** Steht die App für den Betrieb ohne Netz bereit? */
export async function offlineState(): Promise<OfflineState> {
  if (!('serviceWorker' in navigator)) return 'off'
  try {
    const registration = await navigator.serviceWorker.getRegistration()
    return registration?.active ? 'ready' : 'pending'
  } catch {
    return 'off'
  }
}
